import React, {Component, Fragment} from 'react'
import {Card ,CardBody} from 'reactstrap'
import TextArea from 'apa/components/TextArea'
import {connect} from 'react-redux'
import autobind from 'autobind-decorator'
import * as categories from 'catalog/actions/categories'

@connect(
    state => ({
        activeCategory: state.categories.activeCategory,
        activeSubcategory: state.categories.activeSubcategory
    }),
    dispatch => ({
        updateCategory: (category) => dispatch(categories.updateCategory(category)),
        updateSubcategory: (subcategory) => dispatch(categories.updateSubcategory(subcategory)),
    })
)
export default class CategoryIntroduction extends Component {

    constructor(props) {
        super(props)
        const {activeCategory, activeSubcategory} = props
        this.state = {
            activeCategory,
            activeSubcategory
        }
    }
    @autobind
    updateCategory() {
        this.props.updateCategory(this.state.activeCategory);
    }

    @autobind
    updateSubcategory() {
        this.props.updateSubcategory(this.state.activeSubcategory);
    }

    @autobind
    changeCategoryIntroduction(e) {
        const introduction = e.target.value;
        const activeCategory = { ...this.props.activeCategory, introduction: introduction };
        this.setState({activeCategory})
    }

    @autobind
    changeSubcategoryIntroduction(e) {
        const introduction = e.target.value;
        const activeSubcategory = { ...this.props.activeSubcategory, introduction: introduction };
        this.setState({activeSubcategory})
    }


    render() {
        const {
            activeCategory,
            activeSubcategory
        } = this.state
        return (
            <Card>
            <CardBody>
                <h5>Einleitung <small>{this.props.activeCategory.name}</small></h5>
                <TextArea value={activeCategory.introduction}
                    onChange={this.changeCategoryIntroduction}
                    onBlur={this.updateCategory}
                />
                {
                    activeSubcategory &&
                    <Fragment>
                        <h5>Einleitung <small>{this.props.activeSubcategory.name}</small></h5>
                        <TextArea value={activeSubcategory.introduction}
                            onChange={this.changeSubcategoryIntroduction}
                            onBlur={this.updateSubcategory}
                        />
                    </Fragment>
                }
            </CardBody>
        </Card>

        )
    }

}